import { render, staticRenderFns } from "./goodsNameDetails.vue?vue&type=template&id=d9a0ac6c&scoped=true&"
import script from "./goodsNameDetails.vue?vue&type=script&lang=js&"
export * from "./goodsNameDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a0ac6c",
  null
  
)

export default component.exports